export const recruitmentService = {
  getCases: (api, params) => api.get('/recruitment-cases', { params }),
  getCase: (api, id) => api.get(`/recruitment-cases/${id}`),
  createCase: (api, data) => api.post('/recruitment-cases', data),
  updateCase: (api, id, data) => api.put(`/recruitment-cases/${id}`, data),
};
